import React from 'react'
import ShowBarStyle from "./ShowBarStyle.module.css"
//import router
import {Routes,Route,BrowserRouter} from 'react-router-dom'
//import components
import DashBoard from "./Mains/DashBoard"
import MyCources from "./Mains/MyCources"
import AllCources from "./Mains/AllCources"
import EditProfile from "./Mains/EditProfile"



const ShowBar = () => {
    return (
        <div className={ShowBarStyle.container}>

            <Routes>
                <Route path="dashBoard" element={<DashBoard/>}/>
                <Route path="myCources" element={<MyCources/>}/>
                <Route path="allCources" element={<AllCources/>}/>
                <Route path="editProfile" element={<EditProfile/>}/>
             </Routes>
        </div>
    )
}

export default ShowBar
